export default __webpack_public_path__ + "static/media/04-customer-journey.1057928a.svg";